import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { MEDIA_IMAGE_API } from "./apiRoutes";
import { API_BASE_URL } from "../consts";

interface UseGetNewsMediaImageByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getNewsMediaImageById = async (id: string) =>
  await fetch(`${API_BASE_URL}${MEDIA_IMAGE_API}/${id}`);

const useGetNewsMediaImageById = ({
  id,
  queryParams,
}: UseGetNewsMediaImageByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["news-media-image", id],
    queryFn: () => getNewsMediaImageById(id),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetNewsMediaImageById;
